<template>
	<div class="ma-0 pa-0 org-table-root pb-1">
		<v-data-table
			:headers="headers"						
			fixed-header
			:items="orgs"		   
			class="elevation-1 org-table"
			disable-pagination
			hide-default-footer
			height="100%"
			width="100%"
			item-key="id"
			v-model="selectedOrgs"
			>
			<template v-slot:item.id="{ item }">
				<v-container  class="pa-0">
				<v-row class="pa-0">

					<v-col class="pa-0 mx-0">
						<v-icon v-if="isSelected(item)" v-on:click.stop.prevent="doUnSelectOrg(item)">mdi-checkbox-marked</v-icon>
						<v-icon v-else v-on:click.stop.prevent="doSelectOrg(item)">mdi-checkbox-blank-outline</v-icon>						
					</v-col>

                    <v-col class="pa-0">
						<template v-for="n in 2" >
							<span :key="n"/>&#12288;
						</template>
					</v-col>	

					<v-col class="pa-0 code-item">
						{{ item.id}}
					</v-col>					
				</v-row>
				</v-container>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import {default as OrgApi} from "../../../../api/smp/org/OrgApi.js";
	import {default as AuthManageApi} from "../../../../api/smp/sys/AuthManageApi.js";
	
	export default {
		name: 'OrgAuthTable', 
		components: {
		},
		data: () => ({
			headers:[				
				{text: '编号',align: 'start',sortable: false,value: 'id',width:150,divider:true},
                { text: '名称', value: 'name',sortable: false ,width:600,divider:true},				
                { text: '类型', value: 'typeName',sortable: false ,width:150,divider:true},				
                { text: '状态', value: 'statusCaption',sortable: false ,width:100,divider:true},
                
                { text: '', value: '',sortable: false ,divider:false},
			],
			orgs:[],
			selectedOrgs:[],
			editing:false
			}),
		methods:{
			setEditing(editState){
				this.editing = editState;
			},
			doSelectOrg(org){
                // console.log(org.orgId+" do select "+org.selectState);
                // console.log(org);
				if(!this.editing)
					return;
				org.selectState =1;
            },
            isSelected(org){                
				// console.log("isselected");
				// console.log(org.orgId+" -"+(org.selectState==1));
				if(org.selectState==1)
					return true;
                return false;
            },
			doUnSelectOrg(org){
                // console.log(org.orgId+"do unselect"+org.selectState);
                // console.log(org);
				if(!this.editing)
					return;
				org.selectState = -1;
			},
			getSelectedOrgs(){
                
				let me = this;
				let selected = [];
				this.orgs.forEach(function(item){
					if(item.selectState==1)
						selected.push(item);
				});
				return selected;
			},
			
			async loadOrgs(){
				let me = this;
				let resp = await OrgApi.queryOrgs({pageSize:100000});
				
				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取组织信息失败':msg;
					throw new Error(msg);
					return;
				}
				
				let orgs = data.data.orgs;
				orgs.forEach(function(item){
					item.selectState = 0;
				});
				me.orgs = orgs;
			},
			
			async loadOperOrgPriviledge(operId){
				let me = this;
				
				let resp = await AuthManageApi.queryOperOrgPriviledge(operId);
			
				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取组织权限信息失败':msg;
					throw new Error(msg);
					return;
				}

				let priviledgedOrgs = data.data.orgs;					
				priviledgedOrgs.forEach(function(item){
					me.orgs.forEach(function(org){
						if(item.id==org.id){
                          org.selectState=1;
                          console.log("priviledged org:"+org.id);
                          return;
                        }
					});
					
				});
				
			},
			
			
		},
		computed:{
			
		}
	}
</script>

<style scoped>
	.org-table-root{
		
	}
	.org-table{
		height:100%;
	}
	.code-item{
		flex-grow: 100;
	}
</style>
